/**
 * Actions: Payments
 */
import { client as axios } from "@smfa/utils/src";
import {
  getPriceByPlanType,
  getLinkedTableByPlanType,
} from "@smfa/utils/src/common/products";

/**
 * Create a payment intent on the server
 * Validates payment information against product definitions before sending to server
 * @param {object} data - Payment data
 * @param {string} data.plan_type - The selected plan type
 * @param {number} data.amount - The payment amount
 * @param {number} data.linked_id - ID of the record (application or registration)
 * @param {string} [data.linked_table] - Optional, will be determined from plan_type if not provided
 * @returns {Promise} - API response with client_secret and payment_intent_id
 */
export const createPaymentIntent = (data) => {
  // Get linked_table from product definition if not provided
  if (!data.linked_table) {
    data.linked_table = getLinkedTableByPlanType(data.plan_type);
  }

  // Validate the amount against the product definition (added as safeguard)
  const expectedPrice = getPriceByPlanType(data.plan_type);
  if (Math.abs(expectedPrice - data.amount) > 0.01) {
    log.warn(
      `Payment amount (${data.amount}) doesn't match expected price (${expectedPrice}) for plan ${data.plan_type}`,
    );
    data.amount = expectedPrice; // Use correct price to ensure server validation passes
  }

  return axios.post("/create-payment", data);
};

/**
 * Check payment status on the server
 * @param {object} data - Payment data
 * @param {string} data.payment_intent - Stripe payment intent ID
 * @param {string} [data.payment_type] - Type of payment ('online_application', 'register_member')
 * @param {string} [data.registration_token] - Registration token (if applicable)
 * @param {number} [data.application_id] - Application ID (if applicable)
 * @returns {Promise} - API response with payment status
 */
export const checkPaymentStatus = (data) =>
  axios.post("/payment/complete", data);
